<div class="container bg-light position-relative">
    @if (!deviceService.isMobile()) {
    <div class="pt-3"></div>
    }
    <div class="row">
        <div class="col-lg-8 bg-white p-0" [ngClass]="parentClass">
            <div class="bg-white p-3 position-relative">
                <div class="table-sport mx-n3 mx-sm-0">
                    @if (loaded) {
                    <div class="table-sport__content">
                        @if (loadedError) {
                        <div class="tab-pane">
                            <div class="text-center pt-7 app-match-no-data">
                                <svg class="icon icon--64 mb-4">
                                    <use [attr.xlink:href]="'#icon-' + sportName" />
                                </svg>
                                <h4 class="font-weight-bold">{{ 'web.we_are_sorry' | translate }}</h4>
                                <p class="mb-6">{{ 'web.error_data_load' | translate }}</p>
                            </div>
                        </div>
                        } @else { @if (!noCategory()) { @for (event of data; track $index) {
                        <div class="table-sport mx-n3 mx-sm-0 mb-3">
                            @if (!deviceService.isMobile()) {
                            <div class="media w-100 mb-4 flex-column flex-md-row">
                                @if (event.eventStage_circuitImage) {
                                <div class="mr-4 mb-1">
                                    <img src="{{ event.eventStage_circuitImage }}" alt="Circuit" height="130" />
                                </div>
                                }
                                <div class="media-body">
                                    <h1 class="mb-2 d-flex align-items-center">
                                        {{ event.category_description }} - {{ event.eventStage_description }}
                                    </h1>
                                    <div class="row">
                                        @if (event.eventStage_stageInfos?.venue?.name) {
                                        <div class="col-12">
                                            <strong>{{ 'web.motosport_stadium' | translate }}:</strong>
                                            {{ event.eventStage_stageInfos.venue.name }}
                                        </div>
                                        } @if (event.eventStage_stageInfos?.venue?.city) {
                                        <div class="col-12">
                                            <strong>{{ 'web.city' | translate }}:</strong>
                                            @if (event.eventStage_stageInfos.venue.coordinates) {
                                            <a
                                                target="_blank"
                                                [href]="
                                                    'https://www.google.com/maps/place/' +
                                                    event.eventStage_stageInfos.venue.coordinates
                                                "
                                            >
                                                {{ event.eventStage_stageInfos.venue.city }},
                                                {{ event.eventStage_stageInfos.venue.country }}
                                            </a>
                                            } @else {
                                            {{ event.eventStage_stageInfos.venue.city }},
                                            {{ event.eventStage_stageInfos.venue.country }}
                                            }
                                        </div>
                                        } @if (event.eventStage_stageInfos?.venue?.length) {
                                        <div class="col-12">
                                            <strong>{{ 'web.length' | translate }}:</strong>
                                            {{ event.eventStage_stageInfos.venue.length | number }}
                                            {{ 'web.meters' | translate }}
                                        </div>
                                        } @if (event.eventStage_stageInfos?.venue?.capacity) {
                                        <div class="col-12">
                                            <strong>{{ 'web.capacity' | translate }}:</strong>
                                            {{ event.eventStage_stageInfos.venue.capacity | number }}
                                        </div>
                                        } @if (event.eventStage_stageInfos?.venue?.laps) {
                                        <div class="col-12">
                                            <strong>{{ 'web.laps' | translate }}:</strong>
                                            {{ event.eventStage_stageInfos.venue.laps }}
                                        </div>
                                        } @if (event.eventStage_stageInfos?.venue?.debut) {
                                        <div class="col-12">
                                            <strong>{{ 'web.debut' | translate }}:</strong>
                                            {{ event.eventStage_stageInfos.venue.debut }}
                                        </div>
                                        } @if (event.eventStage_stageInfos?.venue?.curves_left) {
                                        <div class="col-12">
                                            <strong>{{ 'web.curves-left' | translate }}:</strong>
                                            {{ event.eventStage_stageInfos.venue.curves_left }}
                                        </div>
                                        } @if (event.eventStage_stageInfos?.venue?.curves_right) {
                                        <div class="col-12">
                                            <strong>{{ 'web.curves-right' | translate }}:</strong>
                                            {{ event.eventStage_stageInfos.venue.curves_right }}
                                        </div>
                                        } @if (event.eventStage_stageInfos?.venue?.url_official) {
                                        <div class="col-12">
                                            <strong>{{ 'web.url' | translate }}:</strong>
                                            @if (event.eventStage_stageInfos.venue.url_official) {
                                            <a target="_blank" [href]="event.eventStage_stageInfos.venue.url_official">
                                                {{ event.eventStage_stageInfos.venue.url_official }}
                                            </a>
                                            }
                                        </div>
                                        }
                                    </div>
                                    @if (event.stages[0]) {
                                    <div class="row mt-2">
                                        @if (event.stages[event.stages.length - 1].startDate) {
                                        <div class="col-12">
                                            <strong>{{ 'web.start_time' | translate }}:</strong>
                                            {{
                                                event.stages[event.stages.length - 1].startDate
                                                    | livDate : 'localDateTime'
                                            }}
                                        </div>
                                        }
                                    </div>
                                    }
                                </div>
                            </div>
                            } @if (deviceService.isMobile()) {
                            <div>
                                <div class="pl-5 pt-5 pr-5 pr-md-3 pb-3">
                                    <div class="media">
                                        @if (event.eventStage_iso) {
                                        <div class="mr-3">
                                            <img
                                                src="/img/flags/1x1/{{ event.eventStage_iso | lowercase }}.svg"
                                                height="130"
                                            />
                                        </div>
                                        }
                                        <div class="media-body">
                                            <div class="d-flex icon-wrapper justify-content-start flex-wrap">
                                                <h1 class="mb-2">{{ event.eventStage_description }}</h1>
                                            </div>
                                            <div class="mb-2 h5 d-flex">
                                                <span class="font-weight-bold mr-1">{{
                                                    event.category_description
                                                }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="nav-wrapper" style="position: relative">
                                    <div class="app-mob-nav-shadow"></div>
                                    <ul
                                        class="nav nav-tabs nav-tabs--shadows font-weight-bold pt-3"
                                        id="tabs-left"
                                        role="tablist"
                                    >
                                        <li class="nav-item">
                                            <a
                                                class="nav-link active px-3 px-md-5 active"
                                                id="tab1"
                                                data-toggle="tab"
                                                href="#tab1-content"
                                                role="tab"
                                                aria-controls="tab1-content"
                                                aria-selected="true"
                                                >{{ 'web.race' | translate }}</a
                                            >
                                        </li>
                                        <li class="nav-item">
                                            <a
                                                class="nav-link px-3 px-md-5"
                                                id="tab2"
                                                data-toggle="tab"
                                                href="#tab2-content"
                                                role="tab"
                                                aria-controls="tab2-content"
                                                aria-selected="false"
                                                >{{ 'web.stage_event_info' | translate }}</a
                                            >
                                        </li>
                                        <li class="nav-item">
                                            <a
                                                class="nav-link px-3 px-md-5"
                                                id="tab3"
                                                data-toggle="tab"
                                                href="#tab3-content"
                                                role="tab"
                                                aria-controls="tab3-content"
                                                aria-selected="false"
                                                >{{ 'web.standings' | translate }}</a
                                            >
                                        </li>
                                        @if (event.eventStage_hasVideo) {
                                        <li class="nav-item">
                                            <a
                                                class="nav-link px-2 px-md-5"
                                                id="tab4"
                                                data-toggle="tab"
                                                href="#tab4-content"
                                                role="tab"
                                                aria-controls="tab4-content"
                                                aria-selected="false"
                                                >{{ 'web.video' | translate }}</a
                                            >
                                        </li>
                                        }
                                    </ul>
                                </div>
                                <div class="tab-content bg-white p-3 position-relative">
                                    <div
                                        class="tab-pane active"
                                        id="tab1-content"
                                        role="tabpanel"
                                        aria-labelledby="tab1"
                                    >
                                        @for (stage of event.stages; track $index) {
                                        <app-stage
                                            (onSelectStage)="loadStage($event)"
                                            (onSelectStageParticipant)="loadStageParticipant($event)"
                                            [stage]="stage"
                                            [categoryName]="event.name"
                                            [showDate]="true"
                                            [sportId]="sportId"
                                            [sportName]="sportName"
                                        ></app-stage>
                                        }
                                    </div>
                                    <div class="tab-pane" id="tab2-content" role="tabpanel" aria-labelledby="tab2">
                                        <div class="row">
                                            <div class="col">
                                                @if (event.eventStage_circuitImage) {
                                                <img
                                                    class="img-responsive mb-3"
                                                    src="{{ event.eventStage_circuitImage }}"
                                                    alt="Circuit"
                                                />
                                                }
                                                <div class="table-responsive">
                                                    <table class="table table-sm stage-table">
                                                        <tbody>
                                                            @if (event.eventStage_stageInfos?.venue?.name) {
                                                            <tr>
                                                                <th class="text-nowrap">
                                                                    {{ 'web.motosport_stadium' | translate }}:
                                                                </th>
                                                                <td>{{ event.eventStage_stageInfos.venue.name }}</td>
                                                            </tr>
                                                            } @if (event.eventStage_stageInfos?.venue?.city) {
                                                            <tr>
                                                                <th class="text-nowrap">
                                                                    {{ 'web.city' | translate }}:
                                                                </th>
                                                                <td>
                                                                    @if (event.eventStage_stageInfos.venue.coordinates)
                                                                    {
                                                                    <a
                                                                        target="_blank"
                                                                        [href]="
                                                                            'https://www.google.com/maps/place/' +
                                                                            event.eventStage_stageInfos.venue
                                                                                .coordinates
                                                                        "
                                                                    >
                                                                        {{ event.eventStage_stageInfos.venue.city }},
                                                                        {{ event.eventStage_stageInfos.venue.country }}
                                                                    </a>
                                                                    } @else {
                                                                    {{ event.eventStage_stageInfos.venue.city }},
                                                                    {{ event.eventStage_stageInfos.venue.country }}
                                                                    }
                                                                </td>
                                                            </tr>
                                                            } @if (event.eventStage_stageInfos?.venue?.length) {
                                                            <tr>
                                                                <th class="text-nowrap">
                                                                    {{ 'web.length' | translate }}:
                                                                </th>
                                                                <td>
                                                                    {{
                                                                        event.eventStage_stageInfos.venue.length
                                                                            | number
                                                                    }}
                                                                    {{ 'web.meters' | translate }}
                                                                </td>
                                                            </tr>
                                                            } @if (event.eventStage_stageInfos?.venue?.capacity) {
                                                            <tr>
                                                                <th class="text-nowrap">
                                                                    {{ 'web.capacity' | translate }}:
                                                                </th>
                                                                <td>
                                                                    {{
                                                                        event.eventStage_stageInfos.venue.capacity
                                                                            | number
                                                                    }}
                                                                </td>
                                                            </tr>
                                                            } @if (event.eventStage_stageInfos?.venue?.laps) {
                                                            <tr>
                                                                <th class="text-nowrap">
                                                                    {{ 'web.laps' | translate }}:
                                                                </th>
                                                                <td>{{ event.eventStage_stageInfos.venue.laps }}</td>
                                                            </tr>
                                                            } @if (event.eventStage_stageInfos?.venue?.debut) {
                                                            <tr>
                                                                <th class="text-nowrap">
                                                                    {{ 'web.debut' | translate }}:
                                                                </th>
                                                                <td>{{ event.eventStage_stageInfos.venue.debut }}</td>
                                                            </tr>
                                                            } @if (event.eventStage_stageInfos?.venue?.curves_left) {
                                                            <tr>
                                                                <th class="text-nowrap">
                                                                    {{ 'web.curves-left' | translate }}:
                                                                </th>
                                                                <td>
                                                                    {{ event.eventStage_stageInfos.venue.curves_left }}
                                                                </td>
                                                            </tr>
                                                            } @if (event.eventStage_stageInfos?.venue?.curves_right) {
                                                            <tr>
                                                                <th class="text-nowrap">
                                                                    {{ 'web.curves-right' | translate }}:
                                                                </th>
                                                                <td>
                                                                    {{ event.eventStage_stageInfos.venue.curves_right }}
                                                                </td>
                                                            </tr>
                                                            } @if (event.eventStage_stageInfos?.venue?.url_official) {
                                                            <tr>
                                                                <th class="text-nowrap">
                                                                    {{ 'web.url' | translate }}:
                                                                </th>
                                                                <td>
                                                                    @if (event.eventStage_stageInfos.venue.url_official)
                                                                    {
                                                                    <a
                                                                        target="_blank"
                                                                        [href]="
                                                                            event.eventStage_stageInfos.venue
                                                                                .url_official
                                                                        "
                                                                    >
                                                                        {{
                                                                            event.eventStage_stageInfos.venue
                                                                                .url_official
                                                                        }}
                                                                    </a>
                                                                    }
                                                                </td>
                                                            </tr>
                                                            } @if ( event.stages[0] && event.stages[event.stages.length
                                                            - 1] .startDate ) {
                                                            <tr>
                                                                <th class="text-nowrap">
                                                                    {{ 'web.start_time' | translate }}:
                                                                </th>
                                                                <td>
                                                                    {{
                                                                        event.stages[event.stages.length - 1].startDate
                                                                            | livDate : 'localDateTime'
                                                                    }}
                                                                </td>
                                                            </tr>
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tab-pane" id="tab3-content" role="tabpanel" aria-labelledby="tab3">
                                        <app-stage-right-col
                                            [sportId]="sportId"
                                            [sportName]="sportName"
                                            [standingsStageId]="stageId"
                                            [stageParticipantStageId]="stageParticipantStageId"
                                            [stageParticipantParticipantId]="stageParticipantParticipantId"
                                        ></app-stage-right-col>
                                    </div>
                                    @if (event.eventStage_hasVideo) {
                                    <div class="tab-pane" id="tab4-content" role="tabpanel" aria-labelledby="tab4">
                                        @for (stage of event.stages; track $index) {
                                        <div class="text-center app-stream-content">
                                            @if (stage?.youtube_video) {
                                            <app-youtube
                                                [video]="stage.youtube_video"
                                                [videoImage]="stage?.youtube_preview"
                                                [stageId]="stage.id"
                                            ></app-youtube>
                                            } @if (stage?.twitch_video) {
                                            <app-twitch [video]="stage.twitch_video"></app-twitch>
                                            } @if (stage?.isport_video) {
                                            <app-isport [video]="stage.isport_video"></app-isport>
                                            } @if (stage?.vimeo_video) {
                                            <app-vimeo [video]="stage.vimeo_video"></app-vimeo>
                                            }
                                        </div>
                                        }
                                    </div>
                                    }
                                </div>
                            </div>
                            } @if (!deviceService.isMobile()) {
                            <div>
                                @for (stage of event.stages; track $index) {
                                <app-stage
                                    (onSelectStage)="loadStage($event)"
                                    (onSelectStageParticipant)="loadStageParticipant($event)"
                                    [stage]="stage"
                                    [categoryName]="event.name"
                                    [showDate]="true"
                                    [sportId]="sportId"
                                    [sportName]="sportName"
                                ></app-stage>
                                }
                            </div>
                            }
                        </div>
                        } @if (!loadedError && data.length == 0) {
                        <div class="tab-pane">
                            <div class="text-center pt-7 app-match-no-data">
                                <svg class="icon icon--64 mb-4">
                                    <use [attr.xlink:href]="'#icon-' + sportName" />
                                </svg>
                                <h4 class="font-weight-bold">{{ 'web.we_are_sorry' | translate }}</h4>
                                <p class="mb-6">{{ 'web.no_data_found' | translate }}</p>
                            </div>
                        </div>
                        }
                        <!-- <div class="d-flex justify-content-center py-2" *ngIf="isMoreResults()">
                          <button type="button" class="btn btn-primary" (click)="showMoreResults()">{{ 'web.next_result' | translate }}</button>
                        </div> -->
                        } @if (noCategory()) {
                        <div class="tab-pane">
                            <div class="text-center pt-7 app-match-no-data">
                                <svg class="icon icon--64 mb-4">
                                    <use [attr.xlink:href]="'#icon-' + sportName" />
                                </svg>
                                <h4 class="font-weight-bold">{{ 'web.we_are_sorry' | translate }}</h4>
                                @if (type == 'live') {
                                <p class="mb-6">{{ 'web.no_live_tab_data_found' | translate }}</p>
                                } @else {
                                <p class="mb-6">{{ 'web.no_data_found' | translate }}</p>
                                }
                            </div>
                        </div>
                        } }
                    </div>
                    } @else {
                    <app-page-loader></app-page-loader>
                    }
                </div>

                @if (alphaAvailLetters.length > 0) {
                <app-alpha-filter
                    class="d-none d-lg-block"
                    [availLetters]="alphaAvailLetters"
                    (onDataChange)="alphaFilter = $event"
                ></app-alpha-filter>
                }
            </div>
        </div>
        <div class="col-lg-4 pl-3 pr-3 d-none d-lg-block" [ngClass]="matchClass">
            @if (!deviceService.isMobile()) {
            <div [class.sticky-parent]="stickyDetail">
                <app-stage-right-col
                    [sportId]="sportId"
                    [sportName]="sportName"
                    [standingsStageId]="stageId"
                    [stageParticipantStageId]="stageParticipantStageId"
                    [stageParticipantParticipantId]="stageParticipantParticipantId"
                ></app-stage-right-col>
            </div>
            }
        </div>
    </div>

    <aside class="nav-sports d-none d-xl-block">
        <nav class="nav flex-column bg-light">
            <app-sport-navigation
                type="aside"
                [date]="paramDate"
                [disabled]="this.first"
                [limit]="asideLimit"
                [sportId]="sportId"
            ></app-sport-navigation>
            <a
                class="nav-link nav-link--more text-uppercase text-reset app-cursor"
                [class.nav-link--more]="isAsideDefault()"
                [class.nav-link--less]="!isAsideDefault()"
                (click)="toggleAssideLimit()"
            >
                @if (isAsideDefault()) {
                <span>{{ 'web.more' | translate }}</span>
                } @if (!isAsideDefault()) {
                <span>{{ 'web.less' | translate }}</span>
                }
            </a>
        </nav>
    </aside>
</div>
